import {
  VStack,
  Text,
  Icon,
  HStack,
  Flex,
  Square,
  Button,
  Divider,
  Spacer,
} from '@chakra-ui/react';

import { IoRemoveCircleOutline, IoCreateOutline } from 'react-icons/io5';

import formatPriceNumber from '~/utils/formatPriceNumber';

import * as fp from 'lodash/fp';

import { CartItem, CartModifier, CartOption } from '~/types/cart';

type ItemProps = {
  item: CartItem;
  allowEdit?: boolean;
  onDelete?: () => void;
  onEdit?: () => void;
};

export default function Item({ item, allowEdit = false, onDelete, onEdit }: ItemProps) {
  const optionsTotal = fp.sumBy<CartModifier>(
    fp.pipe(fp.prop('options'), fp.sumBy<CartOption>(fp.prop('price'))),
  )(item.modifiers);

  const total = (item.price + optionsTotal) * item.count;

  return (
    <VStack align="stretch">
      <Flex justify="space-between" align="center">
        <HStack>
          <Square p={2} borderRadius="5px" bgColor="gray.200">
            <Text textAlign="center" w="1.20rem" fontSize="xs">
              {item.count}
            </Text>
          </Square>
          <Text fontSize="sm" fontWeight="bold">
            {item.name}
          </Text>
        </HStack>
        <Spacer />
        {allowEdit && (
          <Icon as={IoCreateOutline} cursor="pointer" boxSize="1.25rem" onClick={onEdit} />
        )}
      </Flex>

      {item.modifiers.map(({ id, options }) =>
        options.map((option) => (
          <Text fontSize="xs" color="gray.500" key={`${id}_${option.id}`}>
            {option.name} {!fp.eq(option.price, 0) && formatPriceNumber(option.price)}
          </Text>
        )),
      )}

      {item.note && (
        <Text fontSize="xs" color="gray.500">
          {item.note}
        </Text>
      )}

      <Divider borderColor="gray.300" />

      <Flex justify="space-between" align="center">
        {allowEdit && (
          <Button
            p={0}
            size="xs"
            bgColor="white"
            color="gray.500"
            fontWeight="normal"
            iconSpacing={1}
            leftIcon={<Icon as={IoRemoveCircleOutline} color="danger.600" boxSize="1.25rem" />}
            _hover={{
              bgColor: 'white',
              color: 'gray.500',
            }}
            onClick={onDelete}
          >
            刪除餐點
          </Button>
        )}
        <Spacer />
        <Text fontSize="xs" fontWeight="bold">
          {formatPriceNumber(total)}
        </Text>
      </Flex>
    </VStack>
  );
}
